/**
 * Код ошибки чата. Текст по коду переводит `ui/` (`CHAT_ERROR_MESSAGES`), стейт хранит только код —
 * переведённая в reducer строка застыла бы на языке момента ошибки.
 */
export type ChatErrorCode =
  | 'FORBIDDEN'
  | 'UNAVAILABLE'
  | 'TOKEN_LIMIT'
  | 'RATE_LIMIT'
  | 'NO_ACTIVE_TOURNAMENT'
  | 'SEND_FAILED'
  | 'LOAD_FAILED'
  | 'CLEAR_FAILED';

/** Ошибка запроса чата: либо текст сервера (`message`, данные бэкенда), либо код для перевода. */
export interface ChatRequestError {
  message?: string;
  code?: ChatErrorCode;
  status?: number;
}

export function isChatForbiddenError(error: ChatRequestError): boolean {
  return Number(error.status) === 403;
}

export function readChatRequestError(payload: unknown, fallback: ChatErrorCode): ChatRequestError {
  if (typeof payload === 'string' && payload.length > 0) {
    return { message: payload };
  }

  if (payload !== null && typeof payload === 'object') {
    const { message, code, status } = payload as ChatRequestError;
    const error: ChatRequestError = {};

    if (typeof message === 'string' && message.length > 0) error.message = message;
    if (typeof code === 'string') error.code = code;
    if (!error.message && !error.code) error.code = fallback;
    if (status !== undefined) error.status = status;

    return error;
  }

  return { code: fallback };
}
